export default __webpack_public_path__ + "static/media/boxmls.957e0652.png";